export default () => {
  const { $store } = useNuxtApp()
  const { fetchEligibleLabs, enrolledLabs } = useEnrolledLabs()

  /**
   * The core validation logic.
   * Returns a navigation guard result (void or a redirect).
   */
  const checkAccess = async (to) => {
    // Only allow labs access to internal users for the time being
    if (to.path.includes('/labs') && !$store.getters?.user?.internalUser) {
      const home = useHomepageForUser()

      return navigateTo(home)
    }

    await fetchEligibleLabs()
    // Try to find a lab that matches the `to.path`
    const lab = enrolledLabs.value.reduce(
      (acc, lab) => {
        if (acc.found || ![lab.labPath, lab.replacesPath].includes(to.path)) return acc

        acc.found = true

        if (lab.replacesPath === to.path && !Object.hasOwn(to.query, 'classic')) {
          acc.redirect = lab.labPath
        }

        return acc
      },
      { found: false }
    )

    if (lab.found) {
      if (lab?.redirect) {
        return navigateTo(lab.redirect)
      } else {
        return
      }
    } else if (to.path.startsWith('/labs/') && to.path !== '/labs/') {
      return navigateTo('/labs/')
    }
  }

  return {
    checkAccess
  }
}
